			<template>
    <div class="container_page" style="background-color: #fff;padding:20px;">
        <!-- 汇总视图：点击搜索后显示 -->
        <div v-if="showSummary">
            <div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:12px;">
                <a-radio-group v-model="typeModel" button-style="solid" @change="changeTabTop">
                    <a-radio-button style="width: 150px;text-align: center;" value="factory">工厂（{{ factoryCommentNum }}）</a-radio-button>
                    <a-radio-button style="width: 150px;text-align: center;" value="brand">品牌（{{ brandCommentNum }}）</a-radio-button>
                </a-radio-group>
                <div>
                    <a-input v-model="filterData.keywords" placeholder="搜索用户昵称/留言" style="width: 220px;" allow-clear @pressEnter="handleSearchComment"/>
                    <a-button type="primary" style="margin-left:8px;" @click="handleSearchComment">搜索</a-button>
                    <a-button style="margin-left:8px;" @click="resetSearch">重置</a-button>
                    <a-button style="margin-left:12px;" @click="goBackToList">返回列表</a-button>
                </div>
            </div>
            <!-- 评价列表 -->
            <div v-if="!showReplyDetail">
                <a-row v-if="tableData.length > 0">
                    <div v-for="(item,index) in tableData" :key="index" style="margin-top: 10px;border-bottom: 1px solid #f7f7f7;">
                        <div style="font-size:12px;color:#333;margin-bottom:4px;padding-left:2px;font-weight:600;">内容来源：{{ item.businessName || '' }}</div>
                        <!-- 评价内容（与右侧列表一致） -->
                        <div style="display: flex;align-items: center;">
                            <div v-viewer style="width: 50px;height: 50px;border-radius: 25px;border: 2px solid #f7f7f7;overflow: hidden;cursor:pointer;">
                                <img style="width: 50px;height: 50px;border-radius: 25px;object-fit: cover;" v-if="item.avatar" :src="item.avatar" alt=""/>
                            </div>
                            <div style="margin-left: 10px;">
                                {{item.nickname}}
                                <a-tag v-if="item.tagName" color="#2CBD9C" style="margin-left: 6px;">{{item.tagName}}</a-tag>
                                <a-tag v-if="item.pinStatus" color="#1890ff" style="margin-left: 6px;">置顶</a-tag>
                                <a-tag v-if="item.blackStatus" color="black" style="margin-left: 6px;">黑名单</a-tag>
                                <a-tag v-if="item.hiddenStatus" color="#faad14" style="margin-left: 6px;">屏蔽</a-tag>
                                <a-tag v-if="item.commentType === 'MANAGER'" color="#2CBD9C" style="margin-left: 6px;">社会评价</a-tag>
                                <a-tag v-if="item.commentType === 'MANAGER'" :color="item.commentStatus ? '#52c41a' : '#d9d9d9'" style="margin-left: 6px;">
                                    {{ item.commentStatus ? '中文上架' : '中文下架' }}</a-tag>
                                <a-tag v-if="item.commentType === 'MANAGER'" :color="item.commentEnStatus ? '#52c41a' : '#d9d9d9'" style="margin-left: 6px;">{{ item.commentEnStatus ? '英文上架' : '英文下架' }}</a-tag>
                                <a-tag v-if="item.commentType === 'USER'" color="#722ed1" style="margin-left: 6px;">用户评价</a-tag>
                                <span v-if="item.score" style="display:inline-flex;align-items:center;margin-left:6px;vertical-align:middle;">
                                    <a-rate :value="item.score" disabled allow-half style="font-size:14px;"/>
                                    <span style="margin-left:4px;font-size:13px;color:#666;">{{ item.score }}</span>
                                    <a-button type="link" size="small" @click="showScoreDetail(item)" style="font-size:18px;line-height:1;padding:0 4px;min-width:auto;">⋮</a-button>
                                </span>
                            </div>
                        </div>
                        <div style="padding-left: 60px;">{{item.comment}}</div>
                        <div v-viewer style="display:flex;gap:8px;margin-top:8px;flex-wrap:wrap;padding-left:60px;">
                            <img v-for="(imgUrl,i) in item.imgArr" :key="i" :src="imgUrl" style="width:80px;height:80px;object-fit:cover;border:1px solid #eee;cursor:pointer;" alt=""/>
                        </div>
                        <div style="display:flex;align-items:center;justify-content:space-between;padding-left:60px;">
                            <div>{{item.publicTime}}</div>
                            <div style="display:flex;align-items:center;gap:12px;">
<!--                                <span style="color:#999;"><a-icon type="eye"/> {{item.viewNum || 0}}</span>-->
                                <span style="cursor:pointer;color:#999;" @click="handleLike(item)"><a-icon type="like"/> {{(item.likeNum || 0) + (item.virtualLikeNum || 0)}}</span>
                                <span style="cursor:pointer;color:#999;" @click="openReplyWrite(item, null)"><a-icon type="message"/> {{item.commentNum || 0}}</span>
                                <a-dropdown>
                                    <a-icon type="ellipsis" style="cursor:pointer;color:#999;font-size:16px;"/>
                                    <a-menu slot="overlay">
                                        <a-menu-item v-if="!item.hiddenStatus" @click="handleHide(item)">屏蔽此留言</a-menu-item>
                                        <a-menu-item v-if="item.hiddenStatus" @click="handleUnhide(item)">恢复此留言</a-menu-item>
                                        <a-menu-item v-if="!item.blackStatus && item.userId" @click="handleBlack(item)">加入黑名单</a-menu-item>
                                        <a-menu-item v-if="item.blackStatus && item.userId" @click="handleUnblack(item)">取消黑名单</a-menu-item>
                                        <a-menu-item v-if="!item.pinStatus" @click="handlePin(item)">置顶</a-menu-item>
                                        <a-menu-item v-if="item.pinStatus" @click="handleUnpin(item)">取消置顶</a-menu-item>
                                        <a-menu-item @click="handleDelete(item)">删除</a-menu-item>
                                    </a-menu>
                                </a-dropdown>
                            </div>
                        </div>
                        <!-- 回复列表 -->
                        <div v-if="item.replay && item.replay.length" style="padding-left:60px;margin-top:8px;">
                            <div v-for="(rp, ri) in item.replay" :key="ri" v-if="rp" style="background:#f7f7f7;padding:4px 8px;border-radius:4px;margin-bottom:6px;">
                                <div style="display:flex;align-items:center;">
                                    <div v-viewer style="display:inline-block;cursor:pointer;flex-shrink:0;">
                                        <img v-if="rp.replyAvatar" :src="rp.replyAvatar" style="width:24px;height:24px;border-radius:12px;object-fit:cover;" alt=""/>
                                    </div>
                                    <span style="margin-left:6px;font-weight:500;font-size:13px;">{{rp.replyName || '匿名'}}</span>
                                    <a-tag v-if="rp.pinStatus" color="#1890ff" style="margin-left:6px;font-size:11px;">置顶</a-tag>
                                    <a-tag v-if="rp.blackStatus" color="black" style="margin-left:6px;font-size:11px;">黑名单</a-tag>
                                    <a-tag v-if="rp.hiddenStatus" color="#faad14" style="margin-left:6px;font-size:11px;">屏蔽</a-tag>
                                </div>
                                <div style="font-size:13px;color:#333;margin-top:4px;padding-left:30px;"><span v-if="rp.targetName">@{{rp.targetName}}：</span>{{rp.replyContent}}</div>
                                <div v-if="rp.replyImgArr && rp.replyImgArr.length" v-viewer style="display:flex;gap:6px;margin-top:4px;flex-wrap:wrap;padding-left:30px;">
                                    <img v-for="(rimg, rii) in rp.replyImgArr" :key="rii" :src="rimg" style="width:60px;height:60px;object-fit:cover;border:1px solid #eee;cursor:pointer;" alt=""/>
                                </div>
                                <div style="display:flex;align-items:center;justify-content:space-between;margin-top:2px;padding-left:30px;">
                                    <div style="font-size:12px;color:#999;">{{rp.replyTime}}</div>
                                    <div style="display:flex;align-items:center;gap:8px;">
                                        <span style="cursor:pointer;color:#999;" @click="handleLikeReply(item, rp)"><a-icon type="like"/>{{(rp.likeNum || 0) + (rp.virtualLikeNum || 0)}}</span>
                                        <span style="cursor:pointer;color:#999;" @click="openReplyWrite(item, rp)"><a-icon type="message"/> {{rp.commentNum || 0}}</span>
                                        <a-dropdown>
                                            <a-icon type="ellipsis" style="cursor:pointer;color:#999;font-size:16px;"/>
                                            <a-menu slot="overlay">
                                                <a-menu-item v-if="!rp.hiddenStatus" @click="handleHideReply(item, rp)">屏蔽此留言</a-menu-item>
                                                <a-menu-item v-if="rp.hiddenStatus" @click="handleUnhideReply(item, rp)">恢复此留言</a-menu-item>
                                                <a-menu-item v-if="!rp.blackStatus && rp.replyUserId" @click="handleBlack(rp)">加入黑名单</a-menu-item>
                                                <a-menu-item v-if="rp.blackStatus && rp.replyUserId" @click="handleUnblack(rp)">取消黑名单</a-menu-item>
                                                <a-menu-item v-if="!rp.pinStatus" @click="handlePinReply(item, rp)">置顶</a-menu-item>
                                                <a-menu-item v-if="rp.pinStatus" @click="handleUnpinReply(item, rp)">取消置顶</a-menu-item>
                                                <a-menu-item @click="handleDeleteReply(item, rp)">删除</a-menu-item>
                                            </a-menu>
                                        </a-dropdown>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style="display: flex;align-items: center;margin-bottom: 4px;">
                            <div class="left" v-if="item.commentNum > 0" @click="openReplyDetail(item)" style="color:#1890ff;cursor:pointer;padding-left:60px;">共{{item.commentNum}}条回复</div>
                        </div>
                    </div>
                </a-row>
                <div v-if="tableData.length === 0" style="text-align:center;padding:40px 0;color:#999;">暂无数据</div>
                <a-pagination size="small" :current="pageInfo.current" :total="pageInfo.total"
                              :pageSize="pageInfo.pageSize" v-if="pageInfo.total > 0"
                              @change="handlePageChange"
                              style="text-align: center; margin-top: 12px;"/>
            </div>
        </div>

        <!-- 默认视图 -->
        <div v-else>
        <a-row type="flex">
            <!-- 左侧工厂/品牌选择区域 -->
            <a-col flex="300px">
                <div class="lang-radio-wrap">
                    <a-radio-group v-model="typeModel" button-style="solid" @change="changeTabTop">
                        <a-radio-button style="width: 150px;text-align: center;" value="factory">
                            工厂（{{ tableDataFactory.length }}）
                        </a-radio-button>
                        <a-radio-button style="width: 150px;text-align: center;" value="brand">
                            品牌（{{ tableDataBrand.length }}）
                        </a-radio-button>
                    </a-radio-group>
                </div>

                <!-- 搜索框 -->
                <div style="display: flex; margin-top: 10px;">
                    <a-input v-model="searchKeyword" placeholder="搜索工厂/品牌名称" style="width: 200px;"/>
                    <a-button type="primary" @click="handleSearch" style="margin-left: 8px;">搜索</a-button>
                </div>

                <!-- 商家列表 -->
                <div class="list-container" style="width:300px;margin-top:20px;">
                    <div class="list-item" v-for="item in currentList" :class="{ active: selectId === item.businessId }"
                         @click="selectId = item.businessId" :key="item.businessId">
                        <div class="list-item-row">
                            <div class="avatar">
                                <img v-if="item.businessLogo" :src="item.businessLogo" alt=""/>
                            </div>
                            <div class="text-wrap">
                                <div class="title">{{ item.businessName }}</div>
                            </div>
                        </div>
                        <div class="desc">社会评价：{{ item.socialCommentNum || 0 }}条 &nbsp; 用户评价：{{ item.userCommentNum || 0
                            }}条
                        </div>
                    </div>
                </div>
                <a-pagination size="small" :current="listPage.current" :total="listPage.total"
                              :pageSize="listPage.pageSize" v-if="listPage.total > 0"
                              @change="handleFactoryPageChange"
                              style="text-align: center; margin-top: 10px;"/>
            </a-col>

            <!-- 右侧评价顶部栏 -->
            <a-col flex="auto" style="margin-left: 20px; min-width: 0; overflow: hidden; width: 60%;">
                <!-- 顶部筛选栏始终显示 -->
                <a-row type="flex" align="middle" justify="end" style="margin-bottom:10px;">
                    <a-col>
                        <a-input
                            v-model="filterData.keywords"
                            placeholder="搜索用户昵称/留言"
                            style="width: 220px;"
                            allow-clear
                            @pressEnter="getData(1)"
                        />
                        <a-button type="primary" style="margin-left:8px;" @click="handleSearchComment">搜索</a-button>
                        <a-button style="margin-left:8px;" @click="resetSearch">重置</a-button>
                    </a-col>
                </a-row>
                <a-row style="margin-top:12px;margin-bottom:10px;background:#2CBD9C;text-align: center">
                    <a-col>
                        <span style="display:inline-block;padding:6px 20px;color:#fff;font-size:14px;font-weight:500;">
                            {{ currentSelectItem ? currentSelectItem.businessName : '未选择工厂' }}
                        </span>
                    </a-col>
                </a-row>
                <a-row type="flex" align="middle" justify="space-between" style="margin-bottom:10px;">
                    <a-col>
                        <a-radio-group v-model="filterData.commentType" button-style="solid" @change="getData(1)">
                            <a-radio-button style="width: 150px;text-align: center;"
                                            value="MANAGER">社会评价（{{ currentSelectItem ?
                                currentSelectItem.socialCommentNum || 0 : 0 }}）
                            </a-radio-button>
                            <a-radio-button style="width: 150px;text-align: center;" value="USER">用户评价（{{
                                currentSelectItem ? currentSelectItem.userCommentNum || 0 : 0 }}）
                            </a-radio-button>
                        </a-radio-group>
                    </a-col>
                    <a-col>
                        <a-button type="primary" v-if="filterData.commentType == 'USER'" @click="toAdd">新建评价</a-button>
                    </a-col>
                </a-row>
                <a-row style="margin-bottom:10px;">
                    <a-col>
                        <a-select v-model="filterData.hiddenStatus" style="width: 200px;" @change="getData(1)">
                            <a-select-option value="">全部留言（{{ allNum }}条）</a-select-option>
                            <a-select-option value="hidden">已屏蔽（{{ hiddenNum }}条）</a-select-option>
                        </a-select>
                    </a-col>
                </a-row>

                <!-- 评价列表区域：点击回复后隐藏 -->
                <div v-if="!showReplyDetail">
                    <a-row v-if="tableData.length > 0">
                        <div v-for="(item,index) in tableData" :key="index"
                             style="margin-top: 10px;border-bottom: 1px solid #f7f7f7;">
                            <div style="display: flex;align-items: center;">
                                <div v-viewer
                                        style="width: 50px;height: 50px;border-radius: 25px;border: 2px solid #f7f7f7;overflow: hidden;cursor:pointer;">
                                    <img style="width: 50px;height: 50px;border-radius: 25px;object-fit: cover;"
                                         v-if="item.avatar" :src="item.avatar" alt=""/>
                                </div>
                                <div style="margin-left: 10px;">
                                    {{item.nickname}}
                                    <a-tag v-if="item.tagName" color="#2CBD9C" style="margin-left: 6px;">
                                        {{item.tagName}}
                                    </a-tag>
                                    <a-tag v-if="item.pinStatus" color="#1890ff" style="margin-left: 6px;">置顶</a-tag>
                                    <a-tag v-if="item.blackStatus" color="black" style="margin-left: 6px;">黑名单</a-tag>
                                    <a-tag v-if="item.hiddenStatus" color="#faad14" style="margin-left: 6px;">屏蔽</a-tag>
                                    <a-tag v-if="item.commentType === 'MANAGER'" :color="item.commentStatus ? '#52c41a' : '#d9d9d9'" style="margin-left: 6px;">
                                        {{ item.commentStatus ? '中文上架' : '中文下架' }}</a-tag>
                                    <a-tag v-if="item.commentType === 'MANAGER'" :color="item.commentEnStatus ? '#52c41a' : '#d9d9d9'" style="margin-left: 6px;">{{ item.commentEnStatus ? '英文上架' : '英文下架' }}</a-tag>
                                    <span v-if="item.score" style="display:inline-flex;align-items:center;margin-left:6px;vertical-align:middle;">
                                        <a-rate :value="item.score" disabled allow-half style="font-size:14px;"/>
                                        <span style="margin-left:4px;font-size:13px;color:#666;">{{ item.score }}</span>
                                        <a-button type="link" size="small" @click="showScoreDetail(item)" style="font-size:18px;line-height:1;padding:0 4px;min-width:auto;">⋮</a-button>
                                    </span>
                                </div>

                            </div>
                            <!-- 内容 -->
                            <div style="padding-left: 60px;">{{item.comment}}</div>
                            <!-- 图片 -->
                            <div v-viewer style="display:flex;gap:8px;margin-top:8px;flex-wrap:wrap;padding-left:60px;">
                                <img v-for="(imgUrl,i) in item.imgArr" :key="i" :src="imgUrl"
                                     style="width:80px;height:80px;object-fit:cover;border:1px solid #eee;cursor:pointer;"
                                     alt=""/>
                            </div>
                            <div style="display:flex;align-items:center;justify-content:space-between;padding-left:60px;">
                                <div>{{item.publicTime}}</div>
                                <div style="display:flex;align-items:center;gap:12px;">
                                    <span style="color:#999;"><a-icon type="eye"/> {{item.viewNum || 0}}</span>
                                    <span style="cursor:pointer;color:#999;" @click="handleLike(item)"><a-icon
                                            type="like"/> {{(item.likeNum || 0) + (item.virtualLikeNum || 0)}}</span>
                                    <span style="cursor:pointer;color:#999;" @click="openReplyWrite(item, null)"><a-icon
                                            type="message"/> {{item.commentNum || 0}}</span>
                                    <a-dropdown>
                                        <a-icon type="ellipsis" style="cursor:pointer;color:#999;font-size:16px;"/>
                                        <a-menu slot="overlay">
                                            <a-menu-item v-if="!item.hiddenStatus" @click="handleHide(item)">屏蔽此留言
                                            </a-menu-item>
                                            <a-menu-item v-if="item.hiddenStatus" @click="handleUnhide(item)">恢复此留言
                                            </a-menu-item>
                                            <a-menu-item v-if="!item.blackStatus && item.userId"
                                                         @click="handleBlack(item)">加入黑名单
                                            </a-menu-item>
                                            <a-menu-item v-if="item.blackStatus && item.userId"
                                                         @click="handleUnblack(item)">取消黑名单
                                            </a-menu-item>
                                            <a-menu-item v-if="!item.pinStatus" @click="handlePin(item)">置顶
                                            </a-menu-item>
                                            <a-menu-item v-if="item.pinStatus" @click="handleUnpin(item)">取消置顶
                                            </a-menu-item>
                                            <a-menu-item @click="handleDelete(item)">删除</a-menu-item>
                                        </a-menu>
                                    </a-dropdown>
                                </div>
                            </div>

                            <!-- 回复列表 -->
                            <div v-if="item.replay && item.replay.length" style="padding-left:60px;margin-top:8px;">
                                <div v-for="(rp, ri) in item.replay" :key="ri" v-if="rp"
                                     style="background:#f7f7f7;padding:4px 8px;border-radius:4px;margin-bottom:6px;">
                                    <div style="display:flex;align-items:center;">
                                        <div v-viewer style="display:inline-block;cursor:pointer;flex-shrink:0;">
                                            <img v-if="rp.replyAvatar" :src="rp.replyAvatar"
                                                 style="width:24px;height:24px;border-radius:12px;object-fit:cover;"
                                                 alt=""/>
                                        </div>
                                        <span style="margin-left:6px;font-weight:500;font-size:13px;">{{rp.replyName || '匿名'}}</span>
                                        <a-tag v-if="rp.pinStatus" color="#1890ff"
                                               style="margin-left:6px;font-size:11px;">置顶
                                        </a-tag>
                                        <a-tag v-if="rp.blackStatus" color="black"
                                               style="margin-left:6px;font-size:11px;">黑名单
                                        </a-tag>
                                        <a-tag v-if="rp.hiddenStatus" color="#faad14"
                                               style="margin-left:6px;font-size:11px;">屏蔽
                                        </a-tag>
                                    </div>
                                    <div style="font-size:13px;color:#333;margin-top:4px;padding-left:30px;">
                                        <span v-if="rp.targetName" >@{{rp.targetName}}：</span>{{rp.replyContent}}
                                    </div>
                                    <div v-if="rp.replyImgArr && rp.replyImgArr.length" v-viewer
                                         style="display:flex;gap:6px;margin-top:4px;flex-wrap:wrap;padding-left:30px;">
                                        <img v-for="(rimg, rii) in rp.replyImgArr" :key="rii" :src="rimg"
                                             style="width:60px;height:60px;object-fit:cover;border:1px solid #eee;cursor:pointer;"
                                             alt=""/>
                                    </div>
                                    <div style="display:flex;align-items:center;justify-content:space-between;margin-top:2px;padding-left:30px;">
                                        <div style="font-size:12px;color:#999;">{{rp.replyTime}}</div>
                                        <div style="display:flex;align-items:center;gap:8px;">
                                            <span style="cursor:pointer;color:#999;" @click="handleLikeReply(item, rp)"><a-icon
                                                    type="like"/>{{(rp.likeNum || 0) + (rp.virtualLikeNum || 0)}}</span>
                                            <span style="cursor:pointer;color:#999;" @click="openReplyWrite(item, rp)"><a-icon
                                                    type="message"/> {{rp.commentNum || 0}}</span>
                                            <a-dropdown>
                                                <a-icon type="ellipsis"
                                                        style="cursor:pointer;color:#999;font-size:16px;"/>
                                                <a-menu slot="overlay">
                                                    <a-menu-item v-if="!rp.hiddenStatus"
                                                                 @click="handleHideReply(item, rp)">屏蔽此留言
                                                    </a-menu-item>
                                                    <a-menu-item v-if="rp.hiddenStatus"
                                                                 @click="handleUnhideReply(item, rp)">恢复此留言
                                                    </a-menu-item>
                                                    <a-menu-item v-if="!rp.blackStatus && rp.replyUserId"
                                                                 @click="handleBlack(rp)">加入黑名单
                                                    </a-menu-item>
                                                    <a-menu-item v-if="rp.blackStatus && rp.replyUserId"
                                                                 @click="handleUnblack(rp)">取消黑名单
                                                    </a-menu-item>
                                                    <a-menu-item v-if="!rp.pinStatus" @click="handlePinReply(item, rp)">
                                                        置顶
                                                    </a-menu-item>
                                                    <a-menu-item v-if="rp.pinStatus"
                                                                 @click="handleUnpinReply(item, rp)">取消置顶
                                                    </a-menu-item>
                                                    <a-menu-item @click="handleDeleteReply(item, rp)">删除</a-menu-item>
                                                </a-menu>
                                            </a-dropdown>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div style="display: flex;align-items: center;margin-bottom: 4px;">
                                <!-- 增加点击事件 -->
                                <div class="left" v-if="item.commentNum > 0" @click="openReplyDetail(item)"
                                     style="color:#1890ff;cursor:pointer;padding-left:60px;">共{{item.commentNum}}条回复
                                </div>
                            </div>

                        </div>
                    </a-row>
                </div>
                <div v-if="tableData.length === 0" style="text-align:center;padding:40px 0;color:#999;">暂无数据</div>
                <a-pagination size="small" :current="pageInfo.current" :total="pageInfo.total"
                              :pageSize="pageInfo.pageSize" v-if="pageInfo.total > 0"
                              @change="handlePageChange"
                              style="text-align: center; margin-top: 12px;"/>

            </a-col>
            <!-- 这里是右侧的结束 -->
        </a-row>
        </div>

        <!-- 新增/编辑评价弹窗 -->
        <a-modal :title="editModel.title" :visible="editModel.flag" width="800px" @cancel="closeModal" :footer="null">
            <a-form-model :model="editModel" ref="editForm">
                <a-form-model-item label="所属商家">
                    {{ (currentSelectItem && currentSelectItem.businessName) || '' }}
                </a-form-model-item>
                <a-form-model-item label="评价角色" prop="commentManagerUserId" required :rules="[{required:true,message:'请选择评价角色',trigger:'change'}]">
                    <a-select v-model="editModel.commentManagerUserId" placeholder="请选择评价角色" style="width:200px;"
                              show-search option-filter-prop="nickname" :filter-option="filterOption">
                        <a-select-option v-for="(item, index) of tags" :key="index"
                                         :value="item.commentManagerUserId">
                            {{ item.nickname }}
                        </a-select-option>
                    </a-select>
                </a-form-model-item>
                <a-form-model-item label="发布时间" prop="createTime">
                    <a-date-picker v-model="editModel.createTime" format="YYYY-MM-DD HH:mm:ss"
                                   valueFormat="YYYY-MM-DD HH:mm:ss" show-time style="width:300px"/>
                </a-form-model-item>

                <a-form-model-item label="评价内容" prop="comment" :rules="[{required:true,message:'请输入评价内容'}]" required>
                    <div style="display:flex;align-items:flex-start;gap:4px;">
                    <a-textarea placeholder="请输入评价内容" v-model="editModel.comment" rows="4" style="flex:1;" :maxlength="500"/>
                    <a-popover trigger="click" placement="topRight">
                        <template slot="content">
                            <div style="width:280px;max-height:200px;overflow-y:auto;">
                                <span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '😀'">😀</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '😁'">😁</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '😂'">😂</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '🤣'">🤣</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '😃'">😃</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '😄'">😄</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '😅'">😅</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '😆'">😆</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '😉'">😉</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '😊'">😊</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '😋'">😋</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '😎'">😎</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '😍'">😍</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '🥰'">🥰</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '😘'">😘</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '😙'">😙</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '😚'">😚</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '🙂'">🙂</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '🤗'">🤗</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '🤩'">🤩</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '🤔'">🤔</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '🤨'">🤨</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '😐'">😐</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '😑'">😑</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '😶'">😶</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '🙄'">🙄</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '😏'">😏</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '😣'">😣</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '😥'">😥</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '😮'">😮</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '🤐'">🤐</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '😯'">😯</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '😪'">😪</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '😫'">😫</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '😴'">😴</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '😌'">😌</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '😛'">😛</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '😜'">😜</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '😝'">😝</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '🤤'">🤤</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '😒'">😒</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '😓'">😓</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '😔'">😔</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '😕'">😕</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '🙃'">🙃</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '🤑'">🤑</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '😲'">😲</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '☹'">☹</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '️'">️</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '🙁'">🙁</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '😖'">😖</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '😞'">😞</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '😟'">😟</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '😤'">😤</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '😢'">😢</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '😭'">😭</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '😦'">😦</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '😧'">😧</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '😨'">😨</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '😩'">😩</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '🤯'">🤯</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '😬'">😬</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '😰'">😰</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '😱'">😱</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '🥵'">🥵</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '🥶'">🥶</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '😳'">😳</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '🤪'">🤪</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '😵'">😵</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '😡'">😡</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '😠'">😠</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '🤬'">🤬</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '👍'">👍</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '👎'">👎</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '👊'">👊</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '✊'">✊</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '🤛'">🤛</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '🤜'">🤜</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '👏'">👏</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '🙌'">🙌</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '👐'">👐</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '🤲'">🤲</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '🤝'">🤝</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '🙏'">🙏</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '✌'">✌</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '️'">️</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '🤞'">🤞</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '🤟'">🤟</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '🤘'">🤘</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '👌'">👌</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '💪'">💪</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '❤'">❤</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '️'">️</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '🧡'">🧡</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '💚'">💚</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '💙'">💙</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '💜'">💜</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '🖤'">🖤</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '💔'">💔</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '💕'">💕</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '💞'">💞</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '💗'">💗</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '💖'">💖</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '✨'">✨</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '🔥'">🔥</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '⭐'">⭐</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '🌈'">🌈</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '🎉'">🎉</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '🎊'">🎊</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '🎈'">🎈</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '💯'">💯</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '✅'">✅</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '❌'">❌</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '❓'">❓</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '❗'">❗</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '➕'">➕</span><span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;" @click="editModel.comment += '➖'">➖</span>
                            </div>
                        </template>
                        <a-button size="small" style="margin-top:2px;">😊</a-button>
                    </a-popover>
                </div>
                </a-form-model-item>

                <a-form-model-item label="评价图片">
                    <div style="display: flex;align-items: flex-start;flex-wrap:wrap;gap:10px;">
                        <div v-if="editModel.commentImagesList && editModel.commentImagesList.length > 0"
                             class="preview-box">
                            <viewer :images="editModel.commentImagesList">
                                <div class="er_content">
                                    <div class="image-wrapper"
                                         v-for="(img,index) in editModel.commentImagesList" :key="index"
                                         style="position: relative;display: inline-block;margin: 5px;">
                                        <img class="er_content_img" :src="img"
                                             style="width:80px;height:80px;object-fit:cover;display:block;">
                                        <a-icon type="close-circle" style="position:absolute;top:-8px;right:-8px;font-size:18px;color:#f5222d;cursor:pointer;z-index:10;" @click="handleDeleteImage(index)" />
                                    </div>
                                </div>
                            </viewer>
                        </div>
                        <div class="again_upload_box ml12">
                            <input type="file" accept="image/*" multiple @change="uploadDetailImage"/>
                            <a-spin :spinning="uploadingImage" size="small" style="pointer-events:none;">
                                <i class="el-icon-box again_upload_icon"></i>
                                <div class="bold" style="width: 100px">上传评价图片</div>
                            </a-spin>
                        </div>
                    </div>
                </a-form-model-item>

                <!-- 五项评分 -->
                <a-form-model-item label="分项评分">
                            <div style="display: flex;align-items: center;">
                                <span style="width:100px;">{{typeModel == "factory" ? "品控稳定" :"品控安全"}}</span>
                                <a-rate v-model="editModel.qualityStability" allow-half/>
                            </div>
                            <div style="display: flex;align-items: center;">
                                <span style="width:100px;">{{typeModel == "factory" ? "原料溯源" :"配方科学"}}</span>
                                <a-rate v-model="editModel.materialTraceability" allow-half/>
                            </div>
                            <div style="display: flex;align-items: center;">
                                <span style="width:100px;">{{typeModel == "factory" ? "研发生产" :"原料溯源"}}</span>
                                <a-rate v-model="editModel.rdProduction" allow-half/>
                            </div>
                            <div style="display: flex;align-items: center;">
                                <span style="width:100px;">{{typeModel == "factory" ? "资质合规" :"适口性"}}</span>
                                <a-rate v-model="editModel.qualificationCompliance" allow-half/>
                            </div>
                            <div style="display: flex;align-items: center;">
                                <span style="width:100px;">{{typeModel == "factory" ? "卫生环境" :"售后服务"}}</span>
                                <a-rate v-model="editModel.sanitaryEnvironment" allow-half/>
                            </div>
                            <div style="display: flex;align-items: center;margin-top:12px;">
                                <span style="width:100px;">综合得分</span>
                                <a-rate :value="compositeScore" disabled allow-half />
                                <span style="margin-left:8px;font-size:13px;color:#666;">{{ compositeScore }}</span>
                            </div>
                    </a-form-model-item>

                <!-- 提交按钮 -->
                <div style="display: flex;align-items: center;justify-content: center;margin-top:12px;">
                        <a-button @click="closeModal" style="margin-right:12px;">取消</a-button>
                        <a-button @click="sureEdit()" type="primary">发布</a-button>
                    </div>
            </a-form-model>
        </a-modal>

        <!-- 回复列表弹窗 -->
        <a-modal v-model="replyModalWrite.visible" title="回复留言" @ok="handleReplySubmit" width="600px" :zIndex="1001">
            <a-form-model :model="replyModalWrite" :rules="replyRules" ref="replyForm">
                <a-form-model-item label="留言者" prop="commentManagerUserId" required>
                    <div style="margin-bottom:8px;">
                        <a-select v-model="replyModalWrite.commentManagerUserId" placeholder="请选择留言者"
                                  style="width:200px;" allow-clear show-search :filter-option="filterOption">
                            <a-select-option v-for="u in commentManagerUsers" :key="u.commentManagerUserId"
                                             :value="u.commentManagerUserId">{{u.nickname || u.userName}}
                            </a-select-option>
                        </a-select>
                    </div>
                </a-form-model-item>
                    <a-form-model-item label="回复内容" prop="content" required>
                        <div style="display:flex;align-items:flex-start;gap:4px;">
                            <a-textarea v-model="replyModalWrite.content" rows="3" placeholder="请输入回复内容"
                                        style="flex:1;" :maxlength="500"/>
                            <a-popover trigger="click" placement="topRight">
                        <template slot="content">
                            <div style="width:280px;max-height:200px;overflow-y:auto;">
                                <span style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                      @click="insertEmoji('😀')">😀</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('😁')">😁</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('😂')">😂</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('🤣')">🤣</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('😃')">😃</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('😄')">😄</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('😅')">😅</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('😆')">😆</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('😉')">😉</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('😊')">😊</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('😋')">😋</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('😎')">😎</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('😍')">😍</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('🥰')">🥰</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('😘')">😘</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('😗')">😗</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('😙')">😙</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('😚')">😚</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('🙂')">🙂</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('🤗')">🤗</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('🤩')">🤩</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('🤔')">🤔</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('🤨')">🤨</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('😐')">😐</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('😑')">😑</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('😶')">😶</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('🙄')">🙄</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('😏')">😏</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('😣')">😣</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('😥')">😥</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('😮')">😮</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('🤐')">🤐</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('😯')">😯</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('😪')">😪</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('😫')">😫</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('😴')">😴</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('😌')">😌</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('😛')">😛</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('😜')">😜</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('😝')">😝</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('🤤')">🤤</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('😒')">😒</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('😓')">😓</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('😔')">😔</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('😕')">😕</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('🙃')">🙃</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('🤑')">🤑</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('😲')">😲</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('☹️')">☹️</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('🙁')">🙁</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('😖')">😖</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('😞')">😞</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('😟')">😟</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('😤')">😤</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('😢')">😢</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('😭')">😭</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('😦')">😦</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('😧')">😧</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('😨')">😨</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('😩')">😩</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('🤯')">🤯</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('😬')">😬</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('😰')">😰</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('😱')">😱</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('🥵')">🥵</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('🥶')">🥶</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('😳')">😳</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('🤪')">🤪</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('😵')">😵</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('😡')">😡</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('😠')">😠</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('🤬')">🤬</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('👍')">👍</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('👎')">👎</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('👊')">👊</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('✊')">✊</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('🤛')">🤛</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('🤜')">🤜</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('👏')">👏</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('🙌')">🙌</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('👐')">👐</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('🤲')">🤲</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('🤝')">🤝</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('🙏')">🙏</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('✌️')">✌️</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('🤞')">🤞</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('🤟')">🤟</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('🤘')">🤘</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('👌')">👌</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('💪')">💪</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('❤️')">❤️</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('🧡')">🧡</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('💛')">💛</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('💚')">💚</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('💙')">💙</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('💜')">💜</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('🖤')">🖤</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('💔')">💔</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('💕')">💕</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('💞')">💞</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('💗')">💗</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('💖')">💖</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('✨')">✨</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('🔥')">🔥</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('⭐')">⭐</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('🌈')">🌈</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('🎉')">🎉</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('🎊')">🎊</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('🎈')">🎈</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('💯')">💯</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('✅')">✅</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('❌')">❌</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('❓')">❓</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('❗')">❗</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('➕')">➕</span><span
                                    style="cursor:pointer;font-size:20px;display:inline-block;padding:2px;"
                                    @click="insertEmoji('➖')">➖</span>
                            </div>
                        </template>
                        <a-button size="small" style="margin-top:2px;">😊</a-button>
                    </a-popover>
            </div>
                    </a-form-model-item>
                </a-form-model>
            <div style="margin-top: 10px;">
                <div style="display:flex;gap:8px;flex-wrap:wrap;margin-bottom:8px;">
                    <div style="display:flex;align-items:flex-start;flex-wrap:wrap;gap:10px;">
                        <div v-if="replyModalWrite.replyImgList && replyModalWrite.replyImgList.length > 0" class="preview-box">
                            <div class="er_content">
                                <viewer :images="replyModalWrite.replyImgList">
                                <div class="image-wrapper" v-for="(img,idx) in replyModalWrite.replyImgList" :key="idx" style="position:relative;display:inline-block;margin:5px;">
                                    <img class="er_content_img" :src="img" style="width:80px;height:80px;object-fit:cover;display:block;cursor:pointer;">
                                    <a-icon type="close-circle" style="position:absolute;top:-8px;right:-8px;font-size:18px;color:#f5222d;cursor:pointer;z-index:10;" @click="removeReplyImg(idx)" />
                                </div>
                            </viewer>
                            </div>
                        </div>
                        <div class="again_upload_box ml12" v-if="!replyUploading">
                            <input type="file" accept="image/*" multiple @change="uploadReplyImages" :disabled="replyUploading"/>
                            <i class="el-icon-box again_upload_icon"></i>
                            <div class="bold" style="width:100px;">上传图片</div>
                        </div>
                        <a-spin v-if="replyUploading" size="small" style="width:80px;height:80px;display:flex;align-items:center;justify-content:center;" />
                    </div>
                </div>
                <div style="font-size:12px;color:#999;">最多上传9张，只能上传jpg/png格式的文件，文件不能超过3M</div>
            </div>
        </a-modal>

        <a-modal v-model="likeModal.visible" title="编辑点赞数" @ok="handleLikeSave">
            <a-form-model :model="likeModal">
                <a-form-model-item label="原点赞">
                    <a-input-number :value="likeModal.likeNum" style="width: 100%;" disabled/>
                </a-form-model-item>
                <a-form-model-item label="浮动赞数">
                    <a-input-number v-model="likeModal.virtualLikeNum" style="width: 100%;" :min="0"/>
                </a-form-model-item>
                <a-form-model-item label="前端赞数">
                    <a-input-number :value="likeModal.likeNum + likeModal.virtualLikeNum" style="width: 100%;"
                                    disabled/>
                </a-form-model-item>
            </a-form-model>
        </a-modal>

        <a-modal title="留言及回复" :visible="replyModal" width="1000px" :footer="null" @cancel="replyModal = false">
            <div v-if="currentComment">
                <!-- 原评价 -->
                <div style="padding:12px;background:#f5f5f5;border-radius:6px;margin-bottom:16px;">
                    <div style="display:flex;align-items:center;margin-bottom:8px;">
                        <div v-viewer style="display:inline-block;cursor:pointer;flex-shrink:0;margin-right:8px;">
                                <img v-if="currentComment.avatar" :src="currentComment.avatar"
                                     style="width:36px;height:36px;border-radius:50%;object-fit:cover;"/>
                            </div>
                        <span style="font-weight:500;">{{currentComment.nickname}}</span>
                            <a-tag v-if="currentComment.tagName" color="#2CBD9C" style="margin-left: 6px;">
                                {{currentComment.tagName}}
                            </a-tag>
                            <a-tag v-if="currentComment.pinStatus" color="#1890ff" style="margin-left:6px;">置顶</a-tag>
                            <a-tag v-if="currentComment.blackStatus" color="black" style="margin-left:6px;">黑名单</a-tag>
                            <a-tag v-if="currentComment.hiddenStatus" color="#faad14" style="margin-left:6px;">屏蔽</a-tag>
                            <span v-if="currentComment.score" style="display:inline-flex;align-items:center;margin-left:6px;vertical-align:middle;">
                                <a-rate :value="currentComment.score" disabled allow-half style="font-size:14px;"/>
                                <span style="margin-left:4px;font-size:13px;color:#666;">{{ currentComment.score }}</span>
                                <a-button type="link" size="small" @click="showScoreDetail(currentComment)" style="font-size:18px;line-height:1;padding:0 4px;min-width:auto;">⋮</a-button>
                            </span>
                    </div>
                    <div style="padding-left:44px;font-size:14px;color:#333;margin-bottom:6px;">{{currentComment.comment}}</div>
                    <div v-viewer style="padding-left:44px;margin-bottom:6px;">
                        <img v-for="(img,i) in (currentComment.commentImages||'').split(/[,;]/).filter(u=>u)" :key="i" :src="img" style="width:80px;height:80px;object-fit:cover;border:1px solid #eee;cursor:pointer;margin-right:6px;" />
                    </div>
                    <div style="padding-left:44px;font-size:12px;color:#999;">{{currentComment.publicTime}}</div>
                            <!-- 统计操作栏 -->
                            <div style="display:flex;align-items:center;justify-content:space-between;padding-left:44px;margin-top:6px;">
                                <div></div>
                                <div style="display:flex;align-items:center;gap:12px;">
                                    <span style="color:#999;"><a-icon type="eye"/> {{currentComment.viewNum || 0}}</span>
                                    <span style="cursor:pointer;color:#999;" @click="handleLike(currentComment)"><a-icon type="like"/> {{(currentComment.likeNum || 0) + (currentComment.virtualLikeNum || 0)}}</span>
                                    <span style="cursor:pointer;color:#999;" @click="openReplyWrite(currentComment, null)"><a-icon type="message"/> {{currentComment.commentNum || 0}}</span>
                                    <a-dropdown>
                                        <a-icon type="ellipsis" style="cursor:pointer;color:#999;font-size:16px;"/>
                                        <a-menu slot="overlay">
                                            <a-menu-item v-if="!currentComment.hiddenStatus" @click="handleHide(currentComment)">隐藏</a-menu-item>
                                            <a-menu-item v-if="currentComment.hiddenStatus" @click="handleUnhide(currentComment)">恢复显示</a-menu-item>
                                            <a-menu-item v-if="!currentComment.blackStatus && currentComment.userId" @click="handleBlack(currentComment)">拉黑用户</a-menu-item>
                                            <a-menu-item v-if="currentComment.blackStatus && currentComment.userId" @click="handleUnblack(currentComment)">取消拉黑</a-menu-item>
                                            <a-menu-item v-if="!currentComment.pinStatus" @click="handlePin(currentComment)">置顶</a-menu-item>
                                            <a-menu-item v-if="currentComment.pinStatus" @click="handleUnpin(currentComment)">取消置顶</a-menu-item>
                                            <a-menu-item @click="handleDelete(currentComment)">删除</a-menu-item>
                                        </a-menu>
                                    </a-dropdown>
                                </div>
                            </div>
                        </div>
                <div v-if="replyDetailList && replyDetailList.length" style="padding-left:44px;">
                    <div v-for="(item, idx) in replyDetailList" :key="item.replyId || idx"
                         style="margin-top:10px;border-bottom:1px solid #f7f7f7;padding-bottom:8px;">
                        <!-- 头像、昵称、标签 -->
                        <div style="display:flex;align-items:center;">
                            <div v-viewer style="width:36px;height:36px;border-radius:18px;border:2px solid #f7f7f7;overflow:hidden;flex-shrink:0;cursor:pointer;">
                                <img style="width:36px;height:36px;border-radius:18px;object-fit:cover;"
                                     v-if="item.replyAvatar" :src="item.replyAvatar" alt=""/>
                            </div>
                            <div style="margin-left:8px;">
                                {{item.replyName || '匿名'}}
                                <a-tag v-if="item.pinStatus" color="#1890ff" style="margin-left:6px;">置顶</a-tag>
                                <a-tag v-if="item.blackStatus" color="black" style="margin-left:6px;">黑名单</a-tag>
                                <a-tag v-if="item.hiddenStatus" color="#faad14" style="margin-left:6px;">屏蔽</a-tag>
                            </div>
                        </div>
                        <!-- 回复内容 -->
                        <div style="padding-left:44px;"><span v-if="item.targetName" >@{{item.targetName}}：</span>{{item.replyContent}}</div>
                        <!-- 回复图片 -->
                        <div v-if="item.replyImgArr && item.replyImgArr.length" v-viewer
                             style="display:flex;gap:8px;margin-top:8px;flex-wrap:wrap;padding-left:44px;">
                            <img v-for="(imgUrl, i) in item.replyImgArr" :key="i" :src="imgUrl"
                                 style="width:80px;height:80px;object-fit:cover;border:1px solid #eee;cursor:pointer;"
                                 alt=""/>
                        </div>
                        <!-- 底部栏：时间、统计、操作 -->
                        <div style="display:flex;align-items:center;justify-content:space-between;padding-left:44px;">
                            <div style="font-size:12px;color:#999;">{{item.replyTime || ''}}</div>
                            <div style="display:flex;align-items:center;gap:12px;">
<!--                                <span style="color:#999;"><a-icon type="eye"/> {{item.viewNum || 0}}</span>-->
                                <span style="cursor:pointer;color:#999;" @click="handleLike(item)"><a-icon type="like"/> {{(item.likeNum || 0) + (item.virtualLikeNum || 0)}}</span>
                                <span style="cursor:pointer;color:#999;" @click="openReplyWrite(currentComment, item)"><a-icon type="message"/> {{item.commentNum || 0}}</span>
                                <a-dropdown>
                                    <a-icon type="ellipsis" style="cursor:pointer;color:#999;font-size:16px;"/>
                                    <a-menu slot="overlay">
                                        <a-menu-item v-if="!item.hiddenStatus" @click="handleHideReply(currentComment, item)">屏蔽此留言</a-menu-item>
                                        <a-menu-item v-if="item.hiddenStatus" @click="handleUnhideReply(currentComment, item)">恢复此留言</a-menu-item>
                                        <a-menu-item v-if="!item.blackStatus && item.replyUserId" @click="handleBlack(item)">加入黑名单</a-menu-item>
                                        <a-menu-item v-if="item.blackStatus && item.replyUserId" @click="handleUnblack(item)">取消黑名单</a-menu-item>
                                        <a-menu-item v-if="!item.pinStatus" @click="handlePinReply(currentComment, item)">置顶</a-menu-item>
                                        <a-menu-item v-if="item.pinStatus" @click="handleUnpinReply(currentComment, item)">取消置顶</a-menu-item>
                                        <a-menu-item @click="handleDeleteReplyInModal(item)">删除</a-menu-item>
                                    </a-menu>
                                </a-dropdown>
                            </div>
                        </div>
                        <!-- 嵌套回复 (replay) -->
                        <div v-if="item.replay && item.replay.length" style="padding-left:44px;margin-top:6px;">
                            <div v-for="(rp, ri) in item.replay" :key="ri" v-if="rp"
                                 style="background:#f7f7f7;padding:4px 8px;border-radius:4px;margin-bottom:6px;">
                                <div style="display:flex;align-items:center;">
                                    <div v-viewer style="display:inline-block;cursor:pointer;flex-shrink:0;">
                                        <img v-if="rp.replyAvatar" :src="rp.replyAvatar"
                                             style="width:24px;height:24px;border-radius:12px;object-fit:cover;" alt=""/>
                                    </div>
                                    <span style="margin-left:6px;font-weight:500;font-size:13px;">{{rp.replyName || '匿名'}}</span>
                                    <a-tag v-if="rp.pinStatus" color="#1890ff" style="margin-left:6px;font-size:11px;">置顶</a-tag>
                                    <a-tag v-if="rp.blackStatus" color="black" style="margin-left:6px;font-size:11px;">黑名单</a-tag>
                                    <a-tag v-if="rp.hiddenStatus" color="#faad14" style="margin-left:6px;font-size:11px;">屏蔽</a-tag>
                                </div>
                                <div style="font-size:13px;color:#333;margin-top:4px;padding-left:30px;"><span v-if="rp.targetName" >@{{rp.targetName}}：</span>{{rp.replyContent}}</div>
                                <div v-if="rp.replyImgArr && rp.replyImgArr.length" v-viewer
                                     style="display:flex;gap:6px;margin-top:4px;flex-wrap:wrap;padding-left:30px;">
                                    <img v-for="(rimg, rii) in rp.replyImgArr" :key="rii" :src="rimg"
                                         style="width:60px;height:60px;object-fit:cover;border:1px solid #eee;cursor:pointer;" alt=""/>
                                </div>
                                <div style="display:flex;align-items:center;justify-content:space-between;margin-top:2px;padding-left:30px;">
                                    <div style="font-size:12px;color:#999;">{{rp.replyTime}}</div>
                                    <div style="display:flex;align-items:center;gap:8px;">
                                        <span style="cursor:pointer;color:#999;" @click="handleLikeReply(currentComment, rp)"><a-icon type="like"/>{{(rp.likeNum || 0) + (rp.virtualLikeNum || 0)}}</span>
                                        <span style="cursor:pointer;color:#999;" @click="openReplyWrite(currentComment, rp)"><a-icon type="message"/> {{rp.commentNum || 0}}</span>
                                        <a-dropdown>
                                            <a-icon type="ellipsis" style="cursor:pointer;color:#999;font-size:16px;"/>
                                            <a-menu slot="overlay">
                                                <a-menu-item v-if="!rp.hiddenStatus" @click="handleHideReply(currentComment, rp)">屏蔽此留言</a-menu-item>
                                                <a-menu-item v-if="rp.hiddenStatus" @click="handleUnhideReply(currentComment, rp)">恢复此留言</a-menu-item>
                                                <a-menu-item v-if="!rp.blackStatus && rp.replyUserId" @click="handleBlack(rp)">加入黑名单</a-menu-item>
                                                <a-menu-item v-if="rp.blackStatus && rp.replyUserId" @click="handleUnblack(rp)">取消黑名单</a-menu-item>
                                                <a-menu-item v-if="!rp.pinStatus" @click="handlePinReply(currentComment, rp)">置顶</a-menu-item>
                                                <a-menu-item v-if="rp.pinStatus" @click="handleUnpinReply(currentComment, rp)">取消置顶</a-menu-item>
                                                <a-menu-item @click="handleDeleteReply(currentComment, rp)">删除</a-menu-item>
                                            </a-menu>
                                        </a-dropdown>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else style="text-align:center;padding:30px 0;color:#999;">暂无回复</div>
                <!-- 分页器 -->
                <a-pagination size="small"
                              :current="replyDetailPageInfo.current"
                              :total="replyDetailPageInfo.total"
                              :pageSize="replyDetailPageInfo.pageSize"
                              v-if="replyDetailPageInfo.total > 0"
                              @change="handleReplyDetailPageChange"
                              style="text-align:center;margin-top:12px;"/>
            </div>
        </a-modal>

        <!-- 评分详情弹窗 -->
        <a-modal v-model="scoreDetailModal.visible"  title="评分详情" width="420px" :footer="null" :zIndex="1100">
            <div style="padding:8px 0;">
                <div style="display:flex;align-items:center;margin-bottom:12px;">
                    <span style="width:80px;color:#666;">{{typeModel == "factory" ? "品控稳定" :"品控安全"}}</span>
                    <a-rate :value="scoreDetailModal.qualityStability || 0" disabled allow-half style="font-size:16px;"/>
                    <span style="margin-left:8px;font-size:13px;color:#999;">{{ scoreDetailModal.qualityStability || 0 }}</span>
                </div>
                <div style="display:flex;align-items:center;margin-bottom:12px;">
                    <span style="width:80px;color:#666;">{{typeModel == "factory" ? "原料溯源" :"配方科学"}}</span>
                    <a-rate :value="scoreDetailModal.materialTraceability || 0" disabled allow-half style="font-size:16px;"/>
                    <span style="margin-left:8px;font-size:13px;color:#999;">{{ scoreDetailModal.materialTraceability || 0 }}</span>
                </div>
                <div style="display:flex;align-items:center;margin-bottom:12px;">
                    <span style="width:80px;color:#666;">{{typeModel == "factory" ? "研发生产" :"原料溯源"}}</span>
                    <a-rate :value="scoreDetailModal.rdProduction || 0" disabled allow-half style="font-size:16px;"/>
                    <span style="margin-left:8px;font-size:13px;color:#999;">{{ scoreDetailModal.rdProduction || 0 }}</span>
                </div>
                <div style="display:flex;align-items:center;margin-bottom:12px;">
                    <span style="width:80px;color:#666;">{{typeModel == "factory" ? "资质合规" :"适口性"}}</span>
                    <a-rate :value="scoreDetailModal.qualificationCompliance || 0" disabled allow-half style="font-size:16px;"/>
                    <span style="margin-left:8px;font-size:13px;color:#999;">{{ scoreDetailModal.qualificationCompliance || 0 }}</span>
                </div>
                <div style="display:flex;align-items:center;margin-bottom:12px;">
                    <span style="width:80px;color:#666;">{{typeModel == "factory" ? "卫生环境" :"售后服务"}}</span>
                    <a-rate :value="scoreDetailModal.sanitaryEnvironment || 0" disabled allow-half style="font-size:16px;"/>
                    <span style="margin-left:8px;font-size:13px;color:#999;">{{ scoreDetailModal.sanitaryEnvironment || 0 }}</span>
                </div>
            </div>
        </a-modal>
    </div>
</template>

<script>
    import {
        ossUpload
    } from "../../utils/oss";

    import {
        managerFactoryApi,
        getCommentsUserApi,
        getCommentManagerUsersApi,
        getCommentListApi,
        userBlackApi,
        deleteCommentReplyApi,
        updateCommentLikeNumApi,
        replyCommentApi,
        updateCommentStatusApi,
    getCommentDetailApi,
		addCommentsUserApi
    } from "../../api/index";

    export default {
        name: "cardsList",
        data() {
            return {
                tags: [],
                // 评价列表分页、筛选
                tableData: [],
                pageInfo: {
                    current: 1,
                    pageSize: 30,
                    total: 0,
                    showTotal: (total, range) => {
                        return `合计 ${total} 条记录`;
                    },
                },
                filterData: {
                    commentType: "MANAGER",
                    keywords: "",
                    factoryId: "",
                    hiddenStatus: "",
                },
                typeModel: "factory",
                listPage: {
                    current: 1,
                    pageSize: 10,
                    total: 0,
                },
                commentTab: "social",
                loading: false,
                submitLoading: false,
				uploadingImage: false,
                tableDataFactory: [],
                tableDataBrand: [],
                selectId: undefined,
                searchKeyword: "",
                allNum: 0,
                hiddenNum: 0,
                editModel: {
                    flag: false,
                    title: "",
                    commentId: 0,
                    avatar: "",
                    nickname: "",
                    commentManagerUserId: undefined,
                    comment: "",
                    commentStatus: false,
                    setStatus: undefined,
                    setTime: "",
                    commentImages: "",
                    commentImagesList: [],
                    urlName: "",
                    url: "",
                },
                // ========== 新增控制回复详情展示变量 ==========
                showReplyDetail: false,
                currentComment: null, // 当前选中单条评价完整数据
                replyModal: false,
                replyModalWrite: {
                    visible: false,
                    commentId: null,
                    replyId: 0,
                    content: "",
                    replyImgList: [],
                    commentManagerUserId: undefined,
                },
                commentManagerUsers: [],
                replyRules: {
                    commentManagerUserId: [{required: true, message: "请选择留言者", trigger: "change"}],
                    content: [{required: true, message: "请输入回复内容", trigger: "blur"}],
                },
                replyUploading: false,
                likeModal: {
                    visible: false,
                    commentId: null,
                    replyId: 0,
                    likeNum: 0,
                    virtualLikeNum: 0,
                    target: null,
                },
                replyList: [],
                replyDetailPageInfo: {
                    current: 1,
                    pageSize: 10,
                    total: 0,
                },
                replyDetailList: [],
                showSummary: false,
                factoryCommentNum: 0,
                brandCommentNum: 0,
                scoreDetailModal: {
                    visible: false,
                    qualityStability: 0,
                    materialTraceability: 0,
                    rdProduction: 0,
                    qualificationCompliance: 0,
                    sanitaryEnvironment: 0,
                },
            };
        },
        computed: {
            compositeScore() {
                const vals = [this.editModel.qualityStability, this.editModel.materialTraceability, this.editModel.rdProduction, this.editModel.qualificationCompliance, this.editModel.sanitaryEnvironment].filter(v => v != null);
                if (!vals.length) return 0;
                return Math.round(vals.reduce((s, v) => s + v, 0) / vals.length * 10) / 10;
            },
            currentList() {
                return this.typeModel === "factory" ? this.tableDataFactory : this.tableDataBrand;
            },
            // 当前选中商家完整对象
            currentSelectItem() {
                if (!this.selectId) return null;
                return this.currentList.find(item => item.businessId === this.selectId);
            }
        },
        watch: {
            // 选中商家ID变化，自动加载评价列表，同时关闭回复详情
            selectId(newVal) {
                this.showReplyDetail = false;
                this.currentComment = null;
                if (!newVal) {
                    this.tableData = [];
                    this.pageInfo.total = 0;
                    this.allNum = 0;
                    this.hiddenNum = 0;
                    return;
                }
                this.getData(1);
            },
            // 切换评价标签同步筛选参数
            commentTab(newVal) {
                this.filterData.commentType = newVal;
                if (this.selectId) this.getData(1);
            }
        },
        mounted() {
            this.getCompanyData()
            this.getBrandData()
            this.getTagsLabel()
        },
        beforeRouteLeave(to, from, next) {
            localStorage.setItem("cardsList_searchQuery", JSON.stringify(this.filterData));
            next();
        },
        methods: {
            // ========== 新增打开/关闭回复详情方法 ==========
            openReplyDetail(row) {
                this.currentComment = row;
                this.replyDetailPageInfo = { current: 1, pageSize: 10, total: 0 };
                this.replyDetailList = [];
                this.replyModal = true;
                this.loadReplyDetailPage(row.commentId);
            },
            loadReplyDetailPage(commentId) {
                if (!commentId && this.currentComment) {
                    commentId = this.currentComment.commentId;
                }
                if (!commentId) return;
                getCommentDetailApi(commentId, {
                    pageNo: this.replyDetailPageInfo.current,
                    pageSize: this.replyDetailPageInfo.pageSize,
                }).then((res) => {
                    if (res.resultStatus) {
                        const resultData = res.resultData || {};
                        this.replyDetailList = (resultData.dataList || []).map(rp => {
                            let replyImgArr = [];
                            if (rp.replyImages) {
                                replyImgArr = rp.replyImages.split(/[,;]/).filter(url => url.trim());
                            }
                            const processedReplay = (rp.replay || []).filter(r => r).map(r => {
                                let nestedImgArr = [];
                                if (r.replyImages) {
                                    nestedImgArr = r.replyImages.split(/[,;]/).filter(url => url.trim());
                                }
                                return { ...r, replyImgArr: nestedImgArr };
                            });
                            return { ...rp, replyImgArr, replay: processedReplay };
                        });
                        this.replyDetailPageInfo.total = resultData.totalNum || 0;
                    } else {
                        this.replyDetailList = [];
                        this.replyDetailPageInfo.total = 0;
                    }
                }).catch((err) => {
                    console.error(err);
                    this.replyDetailList = [];
                });
            },
            handleReplyDetailPageChange(page) {
                this.replyDetailPageInfo.current = page;
                if (this.currentComment) {
                    this.loadReplyDetailPage(this.currentComment.commentId);
                }
            },
            handleDeleteReplyInModal(item) {
                const vm = this;
                this.$confirm({
                    title: '确认删除',
                    content: '确定要删除该回复吗？',
                    onOk: () => {
                        deleteCommentReplyApi(vm.currentComment.commentId, item.replyId).then((res) => {
                            if (res.resultStatus) {
                                vm.$message.success('已删除');
                                vm.loadReplyDetailPage(vm.currentComment.commentId);
                            } else {
                                vm.$message.error(res.errorMessage || '删除失败');
                            }
                        }).catch((err) => {
                            console.error(err);
                            vm.$message.error('删除失败');
                        });
                    }
                });
            },
            closeReplyDetail() {
                this.showReplyDetail = false;
                this.currentComment = null;
            },

            // 获取评价列表
            getData(page = 1) {
                if (!this.showSummary && !this.currentSelectItem) {
                    this.tableData = [];
                    this.pageInfo.total = 0;
                    this.allNum = 0;
                    this.hiddenNum = 0;
                    return;
                }
                this.pageInfo.current = page;
                if (this.loading) return;
                this.loading = true;

                const params = {
                    pageNo: this.pageInfo.current,
                    pageSize: this.pageInfo.pageSize,
                    keywords: this.filterData.keywords,
                    hiddenStatus: this.filterData.hiddenStatus === "hidden"
                };
                if (!this.showSummary) {
                    params.commentType = this.filterData.commentType;
                }
                if (this.showSummary) {
                    params.businessType = this.typeModel === 'factory' ? 'FACTORY' : 'BRABD';
                } else {
                    params.factoryId = this.currentSelectItem.factoryId;
                }
                getCommentListApi(params)
                    .then((res) => {
                        if (res.resultStatus) {
                            this.tableData = (res.resultData.dataList || []).map(row => {
                                let imgArr = []
                                if (row.commentImages) {
                                    imgArr = row.commentImages.split(/[,;]/).filter(url => url.trim())
                                }
                                const processedReplay = (row.replay || []).filter(rp => rp).map(rp => {
                                    let replyImgArr = []
                                    if (rp.replyImages) {
                                        replyImgArr = rp.replyImages.split(/[,;]/).filter(url => url.trim())
                                    }
                                    return {...rp, replyImgArr}
                                })
                                return {
                                    ...row,
                                    imgArr,
                                    replay: processedReplay
                                }
                            })

                            this.pageInfo.total = res.resultData.totalNum || 0;
                            this.allNum = res.resultData.allNum || 0;
                            this.hiddenNum = res.resultData.hiddenNum || 0;
                            this.factoryCommentNum = res.resultData.factoryCommentNum || 0;
                            this.brandCommentNum = res.resultData.brandCommentNum || 0;
                        } else {
                            this.tableData = [];
                            this.pageInfo.total = 0;
                        }
                    })
                    .catch((err) => {
                        console.error(err);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
            // 关闭弹窗重置表单
            closeModal() {
                this.editModel.flag = false;
                this.resetEditModel();
            },
            // 重置表单空数据
            resetEditModel() {
                this.editModel = {
                    flag: false,
                    title: "",
                    commentId: 0,
                    avatar: "",
                    nickname: "",
                    commentManagerUserId: undefined,
                    comment: "",
                    commentStatus: false,
                    setStatus: undefined,
                    setTime: "",
                    commentImages: "",
                    commentImagesList: [],
                    urlName: "",
                    url: "",
                    factoryLangId: 0,
                    createTime: "",
                    qualityStability: 0,
                    materialTraceability: 0,
                    rdProduction: 0,
                    qualificationCompliance: 0,
                    sanitaryEnvironment: 0,
                }
            },
            // 图片上传
            uploadDetailImage(e) {
                const files = Array.from(e.target.files);
                if (!files.length) return;
                const maxCanAdd = 9 - (this.editModel.commentImagesList || []).length;
                if (maxCanAdd <= 0) {
                    this.$message.warning('最多上传9张图片');
                    e.target.value = '';
                    return;
                }
                if (files.length > maxCanAdd) {
                    this.$message.warning('只能再选 ' + maxCanAdd + ' 张，已自动截取前 ' + maxCanAdd + ' 张');
                }
                const toUpload = files.slice(0, maxCanAdd);
                for (const f of toUpload) {
                    if (f.size > 3 * 1024 * 1024) {
                        this.$message.warning('图片大小不能超过3M');
                        e.target.value = '';
                        return;
                    }
                }
                this.uploadingImage = true;
                let completed = 0;
                toUpload.forEach((file) => {
                    ossUpload(file, '', 'image/').then((res) => {
                        if (!this.editModel.commentImagesList) this.editModel.commentImagesList = [];
                        this.editModel.commentImagesList.push(res.url);
                    }).catch((err) => {
                        console.error(err);
                        this.$message.error('图片上传失败');
                    }).finally(() => {
                        completed++;
                        if (completed >= toUpload.length) this.uploadingImage = false;
                    });
                });
                e.target.value = '';
            },
            // 删除单张图片
            handleDeleteImage(index) {
                this.editModel.commentImagesList.splice(index, 1);
            },
            // 获取评价角色下拉
            getTagsLabel() {
                getCommentManagerUsersApi({
                    pageNo: 1,
                    pageSize: 10000,
                    commentManagerUserStatus: true,
                })
                    .then((res) => {
                        if (res.resultStatus) {
                            this.tags = res.resultData.dataList || [];
                        } else {
                            this.tags = [];
                        }
                    })
                    .catch((err) => {
                        console.error(err);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
            // 新建评价弹窗
            toAdd() {
                if (!this.currentSelectItem) {
                    this.$message.warning("请先左侧选择工厂/品牌");
                    return;
                }
                this.resetEditModel();
                this.editModel.flag = true;
                this.editModel.title = "新建评价";
                this.editModel.factoryLangId = this.currentSelectItem.businessId;
            },
            // 提交保存评价
            sureEdit() {
                this.$refs.editForm.validate((valid) => {
                    if (!valid) return;
                    if (this.submitLoading) return;
                    this.submitLoading = true;
                    const imgStr = Array.isArray(this.editModel.commentImagesList) ?
                    this.editModel.commentImagesList.filter(Boolean).join(';') :
                    '';
                    const params = {
                        factoryLangId: this.currentSelectItem.businessLangId,
                        comment: this.editModel.comment || "",
                        commentManagerUserId: this.editModel.commentManagerUserId || '',
                        commentImages: imgStr,
                        createTime: this.editModel.createTime ?? null,
                        qualityStability: Number(this.editModel.qualityStability) || 0,
                        materialTraceability: Number(this.editModel.materialTraceability) || 0,
                        rdProduction: Number(this.editModel.rdProduction) || 0,
                        qualificationCompliance: Number(this.editModel.qualificationCompliance) || 0,
                        sanitaryEnvironment: Number(this.editModel.sanitaryEnvironment) || 0,
                    }
                    addCommentsUserApi(params)
                        .then((res) => {
                            if (res.resultStatus) {
                                this.$message.success("新增评价成功");
                                this.editModel.flag = false;
                                this.getData(1);
                            } else {
                                this.$message.error(res.errorMessage || "提交失败");
                            }
                        })
                        .catch((error) => {
                            console.error(error);
                            this.$message.error("接口请求异常");
                        })
                        .finally(() => {
                            this.submitLoading = false;
                        });
                });
            },
            // 切换工厂/品牌Tab
            changeTabTop() {
                this.selectId = undefined;
                this.tableData = [];
                this.pageInfo.total = 0;
                this.listPage.current = 1;
                this.listPage.total = 0;
                // 切换tab同时关闭回复详情
                this.showReplyDetail = false;
                this.currentComment = null;
                // 根据当前tab加载数据
                if (this.showSummary) {
                    this.getData(1);
                } else if (this.typeModel === 'factory') {
                    this.getCompanyData();
                } else {
                    this.getBrandData();
                }
            },
            // 下拉搜索过滤
            handlePageChange(page) {
                this.pageInfo.current = page;
                this.getData(page);
            },
            // 工厂/品牌列表分页
            handleFactoryPageChange(page) {
                this.listPage.current = page;
                if (this.typeModel === 'factory') {
                    this.getCompanyData();
                } else {
                    this.getBrandData();
                }
            },
            handleSearch() {
                this.listPage.current = 1;
                if (this.typeModel === 'factory') {
                    this.getCompanyData();
                } else {
                    this.getBrandData();
                }
            },
            // 用户昵称/留言搜索
            handleSearchComment() {
                if (!this.filterData.keywords || !this.filterData.keywords.trim()) {
                    this.$message.warning('请输入搜索内容');
                    return;
                }
                this.showSummary = true;
                this.getData(1);
            },
            // 黑名单操作
            handleBlack(item) {
                const userId = item.userId || item.replyUserId;
                if (!userId) return;
                this.$confirm({
                    title: '确认加入黑名单',
                    content: '确定要将该用户加入黑名单吗？',
                    onOk: () => {
                        userBlackApi({userId}).then((res) => {
                            if (res.resultStatus) {
                                item.blackStatus = true;
                                this.$message.success('已加入黑名单');
                            } else {
                                this.$message.error(res.errorMessage || '操作失败');
                            }
                        }).catch((err) => {
                            console.error(err);
                            this.$message.error('操作失败');
                        });
                    }
                });
            },
            // 屏蔽此留言
            handleHide(item) {
                updateCommentStatusApi(item.commentId, 0, {commentStatusType: 'HIDDEN'}).then((res) => {
                    if (res.resultStatus) {
                        item.hiddenStatus = true;
                        this.$message.success('已屏蔽');
                    } else {
                        this.$message.error(res.errorMessage || '操作失败');
                    }
                }).catch((err) => {
                    console.error(err);
                    this.$message.error('操作失败');
                });
            },
            // 恢复留言
            handleUnhide(item) {
                updateCommentStatusApi(item.commentId, 0, {commentStatusType: 'HIDDEN'}).then((res) => {
                    if (res.resultStatus) {
                        item.hiddenStatus = false;
                        this.$message.success('已恢复');
                    } else {
                        this.$message.error(res.errorMessage || '操作失败');
                    }
                }).catch((err) => {
                    console.error(err);
                    this.$message.error('操作失败');
                });
            },
            // 置顶
            handlePin(item) {
                updateCommentStatusApi(item.commentId, 0, {commentStatusType: 'PIN'}).then((res) => {
                    if (res.resultStatus) {
                        item.pinStatus = true;
                        this.$message.success('已置顶');
                    } else {
                        this.$message.error(res.errorMessage || '操作失败');
                    }
                }).catch((err) => {
                    console.error(err);
                    this.$message.error('操作失败');
                });
            },
            // 取消置顶
            handleUnpin(item) {
                updateCommentStatusApi(item.commentId, 0, {commentStatusType: 'PIN'}).then((res) => {
                    if (res.resultStatus) {
                        item.pinStatus = false;
                        this.$message.success('已取消置顶');
                    } else {
                        this.$message.error(res.errorMessage || '操作失败');
                    }
                }).catch((err) => {
                    console.error(err);
                    this.$message.error('操作失败');
                });
            },
            // 取消黑名单
            handleUnblack(item) {
                const userId = item.userId || item.replyUserId;
                if (!userId) return;
                this.$confirm({
                    title: '确认取消黑名单',
                    content: '确定要取消该用户的黑名单吗？',
                    onOk: () => {
                        userBlackApi({userId}).then((res) => {
                            if (res.resultStatus) {
                                item.blackStatus = false;
                                this.$message.success('已取消黑名单');
                            } else {
                                this.$message.error(res.errorMessage || '操作失败');
                            }
                        }).catch((err) => {
                            console.error(err);
                            this.$message.error('操作失败');
                        });
                    }
                });
            },

            // 回复操作 - 屏蔽
            handleHideReply(item, rp) {
                updateCommentStatusApi(item.commentId, rp.replyId, {commentStatusType: 'HIDDEN'}).then((res) => {
                    if (res.resultStatus) {
                        rp.hiddenStatus = true;
                        this.$message.success('已屏蔽');
                    } else {
                        this.$message.error(res.errorMessage || '操作失败');
                    }
                }).catch((err) => {
                    console.error(err);
                    this.$message.error('操作失败');
                });
            },
            // 回复操作 - 恢复
            handleUnhideReply(item, rp) {
                updateCommentStatusApi(item.commentId, rp.replyId, {commentStatusType: 'HIDDEN'}).then((res) => {
                    if (res.resultStatus) {
                        rp.hiddenStatus = false;
                        this.$message.success('已恢复');
                    } else {
                        this.$message.error(res.errorMessage || '操作失败');
                    }
                }).catch((err) => {
                    console.error(err);
                    this.$message.error('操作失败');
                });
            },
            // 回复操作 - 置顶
            handlePinReply(item, rp) {
                updateCommentStatusApi(item.commentId, rp.replyId, {commentStatusType: 'PIN'}).then((res) => {
                    if (res.resultStatus) {
                        rp.pinStatus = true;
                        this.$message.success('已置顶');
                    } else {
                        this.$message.error(res.errorMessage || '操作失败');
                    }
                }).catch((err) => {
                    console.error(err);
                    this.$message.error('操作失败');
                });
            },
            // 回复操作 - 取消置顶
            handleUnpinReply(item, rp) {
                updateCommentStatusApi(item.commentId, rp.replyId, {commentStatusType: 'PIN'}).then((res) => {
                    if (res.resultStatus) {
                        rp.pinStatus = false;
                        this.$message.success('已取消置顶');
                    } else {
                        this.$message.error(res.errorMessage || '操作失败');
                    }
                }).catch((err) => {
                    console.error(err);
                    this.$message.error('操作失败');
                });
            },
            // 回复操作 - 删除
            handleDeleteReply(item, rp) {
                this.$confirm({
                    title: '确认删除',
                    content: '确定要删除该回复吗？',
                    onOk: () => {
                        deleteCommentReplyApi(item.commentId, rp.replyId).then((res) => {
                            if (res.resultStatus) {
                                this.$message.success('已删除');
                                item.replay = item.replay.filter(r => r.replyId !== rp.replyId);
                            } else {
                                this.$message.error(res.errorMessage || '删除失败');
                            }
                        }).catch((err) => {
                            console.error(err);
                            this.$message.error('删除失败');
                        });
                    }
                });
            },
            // 评价 - 删除
            handleDelete(item) {
                this.$confirm({
                    title: '确认删除',
                    content: '确定要删除该评价吗？',
                    onOk: () => {
                        deleteCommentReplyApi(item.commentId, 0).then((res) => {
                            if (res.resultStatus) {
                                this.$message.success('已删除');
                                this.getData(this.pageInfo.current);
                            } else {
                                this.$message.error(res.errorMessage || '删除失败');
                            }
                        }).catch((err) => {
                            console.error(err);
                            this.$message.error('删除失败');
                        });
                    }
                });
            },
            openReplyWrite(item, rp) {
                this.replyModalWrite = {
                    visible: true,
                    commentId: item.commentId,
                    replyId: rp ? rp.replyId : 0,
                    content: "",
                    replyImgList: [],
                    commentManagerUserId: undefined,
                };
                getCommentManagerUsersApi({pageSize: 10000, commentManagerUserStatus: true}).then((res) => {
                    if (res.resultStatus) {
                        this.commentManagerUsers = res.resultData.dataList || [];
                    }
                }).catch((err) => console.error(err));
            },
            uploadReplyImages(e) {
                const files = Array.from(e.target.files);
                this.replyUploading = true;


                let completed = 0;
                const total = Math.min(files.length, 9 - (this.replyModalWrite.replyImgList || []).length);
                if (total <= 0) {
                    this.replyUploading = false;
                    return;
                }
                files.forEach((file) => {
                    if ((this.replyModalWrite.replyImgList || []).length >= 9) return;
                    ossUpload(file, '', 'image/').then((res) => {
                        if (!this.replyModalWrite.replyImgList) this.replyModalWrite.replyImgList = [];
                        this.replyModalWrite.replyImgList.push(res.url);
                    }).catch((err) => {
                        console.error(err);
                        this.$message.error('图片上传失败');
                    }).finally(() => {
                        completed++;
                        if (completed >= total) this.replyUploading = false;
                    });
                });
                e.target.value = '';
            },
            insertEmoji(emoji) {
                this.replyModalWrite.content += emoji;
            },
            removeReplyImg(idx) {
                if (this.replyModalWrite.replyImgList) {
                    this.replyModalWrite.replyImgList.splice(idx, 1);
                }
            },
            handleReplySubmit() {
                this.$refs.replyForm.validate((valid) => {
                    if (!valid) return;
                    replyCommentApi(this.replyModalWrite.commentId, this.replyModalWrite.replyId, {
						comment: this.replyModalWrite.content,
						commentImages: (this.replyModalWrite.replyImgList || []).join(';'),
                        commentManagerUserId: this.replyModalWrite.commentManagerUserId
                    }).then((res) => {
                        if (res.resultStatus) {
                            this.$message.success('回复成功');
                            this.replyModalWrite.visible = false;
                            this.getData(this.pageInfo.current);
                            // 如果「留言及回复」弹窗已打开，同步刷新回复列表
                            if (this.replyModal) {
                                this.loadReplyDetailPage(this.replyModalWrite.commentId);
                            }
                        } else {
                            this.$message.error(res.errorMessage || '回复失败');
                        }
                    }).catch((err) => {
                        console.error(err);
                        this.$message.error('回复失败');
                    });
                });
            },
            handleLikeReply(comment, reply) {
                this.likeModal = {
                    visible: true,
                    commentId: comment.commentId,
                    replyId: reply.replyId,
                    likeNum: reply.likeNum || 0,
                    virtualLikeNum: reply.virtualLikeNum || 0,
                    target: reply,
                };
            },
            handleLike(item) {
                this.likeModal = {
                    visible: true,
                    commentId: item.commentId,
                    replyId: item.replyId || 0,
                    likeNum: item.likeNum || 0,
                    virtualLikeNum: item.virtualLikeNum || 0,
                    target: item,
                };
            },
            handleLikeSave() {
                const data = {
                    likeNum: this.likeModal.likeNum,
                    virtualLikeNum: this.likeModal.virtualLikeNum
                };
                updateCommentLikeNumApi(this.likeModal.commentId, this.likeModal.replyId, data).then((res) => {
                    if (res.resultStatus) {
                        this.likeModal.target.likeNum = this.likeModal.likeNum;
                        this.likeModal.target.virtualLikeNum = this.likeModal.virtualLikeNum;
                        this.likeModal.visible = false;
                        this.$message.success('保存成功');
                    } else {
                        this.$message.error(res.errorMessage || '保存失败');
                    }
                }).catch((err) => {
                    console.error(err);
                    this.$message.error('保存失败');
                });
            },
            showScoreDetail(item) {
                this.scoreDetailModal = {
                    visible: true,
                    qualityStability: item.qualityStability || 0,
                    materialTraceability: item.materialTraceability || 0,
                    rdProduction: item.rdProduction || 0,
                    qualificationCompliance: item.qualificationCompliance || 0,
                    sanitaryEnvironment: item.sanitaryEnvironment || 0,
                };
            },
            goBackToList() {
                this.showSummary = false;
                this.filterData.keywords = '';
                this.searchKeyword = '';
            },
            resetSearch() {
                this.filterData.keywords = '';
                // this.filterData.hiddenStatus = '';
                // this.filterData.commentType = 'MANAGER';
                // this.getData(1);
            },
            filterOption(input, option) {
                return option.componentOptions && option.componentOptions.children
                    ? option.componentOptions.children[0].text.toLowerCase().includes(input.toLowerCase())
                    : true;
            },
            // 获取工厂列表
            getCompanyData() {
                managerFactoryApi({
                    pageNo: this.listPage.current,
                    pageSize: this.listPage.pageSize,
                    businessType: 'FACTORY',
                    commentStatus: false,
                    lang: "CH",
                    businessName: this.searchKeyword || undefined
                })
                    .then((res) => {
                        if (res.resultStatus) {
                            this.tableDataFactory = res.resultData.dataList || [];
                            if (this.typeModel === 'factory') this.listPage.total = res.resultData.totalNum || 0;
                            console.log('factory resp:', res.resultData);
                            if (this.tableDataFactory.length > 0 && !this.selectId) {
                                this.selectId = this.tableDataFactory[0].businessId;
                            }
                        } else {
                            this.tableDataFactory = [];
                            if (this.typeModel === 'factory') this.listPage.total = 0;
                        }
                    })
                    .catch((err) => {
                        console.error(err);
                    });
            },
            // 获取品牌列表
            getBrandData() {
                managerFactoryApi({
                    pageNo: this.listPage.current,
                    pageSize: this.listPage.pageSize,
                    businessType: 'BRABD',
                    commentStatus: false,
                    lang: "CH",
                    businessName: this.searchKeyword || undefined
                })
                    .then((res) => {
                        if (res.resultStatus) {
                            this.tableDataBrand = res.resultData.dataList || [];
                            if (this.typeModel === 'brand') this.listPage.total = res.resultData.totalNum || 0;
                            console.log('brand resp:', res.resultData);
                            // 切换品牌Tab时默认选中第一个品牌
                            if (this.typeModel === 'brand' && this.tableDataBrand.length > 0 && !this.selectId) {
                                this.selectId = this.tableDataBrand[0].businessId;
                            }
                        } else {
                            this.tableDataBrand = [];
                            this.listPage.total = 0;
                        }
                    })
                    .catch((err) => {
                        console.error(err);
                    });
            },
        },
    };
</script>

<style>
	.compact-form .ant-form-item {
		margin-bottom: 8px;
	}
</style>
<style lang="less" scoped>
	/deep/ .ant-modal-body {
		padding-top: 8px !important;
	}
	/deep/ .ant-form-item {
		margin-bottom: 6px !important;
	}
	/deep/ .ant-modal .ant-row {
		margin-bottom: 3px !important;
	}

    .lang-radio-wrap {
        /deep/ .ant-radio-button-wrapper-checked {
            border-color: #00b887;

            &::before {
                background-color: #00b887;
            }
        }

        /deep/ .ant-radio-button-wrapper {
            margin-right: -1px;
        }
    }

    .list-container {
        .list-item {
            .list-item-row {
                display: flex;
                align-items: flex-start;
            }

            padding: 12px;
            border-radius: 6px;
            cursor: pointer;
            margin-bottom: 8px;
            background-color: #f7f7f7;

            &.active {
                background: #2CBD9C;
                border: 1px solid #2CBD9C;
                border-left: 3px solid #2CBD9C;

                .title {
                    color: #fff !important;
                }

                .desc {
                    color: #e6f7ff !important;
                    margin-top: 5px;
                }
            }

            .avatar {
                width: 36px;
                height: 36px;
                border-radius: 50%;
                background: #91d5ff;
                flex-shrink: 0;
                margin-right: 10px;

                img {
                    width: 100%;
                    height: 100%;
                    border-radius: 50%;
                    object-fit: cover;
                }
            }

            .text-wrap {
                flex: 1;

                .title {
                    font-size: 15px;
                    color: #333;
                    margin-bottom: 6px;
                }
            }

            .desc {
                font-size: 13px;
                color: #666;
                text-align: left;
            }
        }
    }

    .again_upload_box {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100px;
        height: 80px;
        border: 1px dashed #ccc;
        border-radius: 4px;
        cursor: pointer;
        position: relative;

        input {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            opacity: 0;
            cursor: pointer;
        }

        i {
            font-size: 20px;
            color: #999;
            margin-bottom: 4px;
        }

        .bold {
            font-size: 12px;
            color: #666;
            text-align: center;
        }
    }

    .mr12 {
        margin-right: 12px;
    }
</style>
